import {
  FilterOptionMatchStrategy,
  OPERATIONS,
  VALUE_MATCH,
} from '../interfaces/filter-selected-value.interface';

export const AppFilterHelper = {
  getMatchStrategySingle: (
    groupName?: string,
    exclude?: boolean,
    operation = OPERATIONS.AND,
  ): FilterOptionMatchStrategy => {
    return {
      operation,
      valueMatch: VALUE_MATCH.SINGLE,
      groupName,
      exclude,
    };
  },
  getMatchStrategyMultiple: (
    groupName?: string,
    exclude?: boolean,
    operation = OPERATIONS.AND,
  ): FilterOptionMatchStrategy => {
    return {
      operation,
      valueMatch: VALUE_MATCH.MULTIPLE,
      groupName,
      exclude,
    };
  },
  getMatchStrategyRange: (
    groupName?: string,
    exclude?: boolean,
    operation = OPERATIONS.AND,
  ): FilterOptionMatchStrategy => {
    return {
      operation,
      valueMatch: VALUE_MATCH.RANGE,
      groupName,
      exclude,
    };
  },
};
